import { z } from 'zod';
import { defineRecordKind } from '../registry.js';
import { longtext } from './common.js';

// 記録（帳票ではない、その場の事実）。record.body の形。
// 旧実装にケアマネの訪問記録の型は無い（第5表の EventRecord に直接書いていた）。ここは新設で最小限

export const visitNoteSchema = z
  .object({
    text: longtext('内容').min(1),
    visitedAt: z.string().min(1).meta({ kind: 'date' }).optional().describe('訪問日時'),
    place: z.string().optional().describe('場所'),
    attendees: z.array(z.string().min(1)).optional().describe('同席者'),
  })
  .strict();
export type VisitNoteBody = z.infer<typeof visitNoteSchema>;

export const visitNoteKind = defineRecordKind({
  app: 'caremanager',
  kind: 'visit_note',
  name: '訪問記録',
  version: 1,
  schema: visitNoteSchema,
  description: '訪問・面談の記録。自由記述が主で、構造化項目は任意',
});
